import { $taskClientFeedback, $taskClientFeedbackSummary } from './states';
import { fetchTaskClientFeedback, fetchTaskClientFeedbackSummary } from './effects';

// Fetch clients
$taskClientFeedback.on(fetchTaskClientFeedback.doneData, (_, data) => data);

// Fetch clients
$taskClientFeedbackSummary.on(fetchTaskClientFeedbackSummary.doneData, (_, data) => data);
